import React from 'react';
import eventBus from '../lib/eventBus';
import './modal.css';
import axios from 'axios';
import { API_BASE_URL } from '../lib/constants';
import AddressModal from './AddressModal';

export default function AddressSection() {
  const [addresses, setAddresses] = React.useState<any[]>([]);
  const [editId, setEditId] = React.useState<number | null>(null);
  const [editForm, setEditForm] = React.useState({ nickname: '', address_line1: '', address_line2: '', city: '', state: '', postal_code: '' });
  const [editError, setEditError] = React.useState<string | null>(null);
  const [showModal, setShowModal] = React.useState(false);
  const [form, setForm] = React.useState({ nickname: '', address_line1: '', address_line2: '', city: '', state: '', postal_code: '' });
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(false);
  const states = [
    'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
  ];

  const fetchAddresses = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/addresses/`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      setAddresses(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      setAddresses([]);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchAddresses();
  }, []);

  const handleCreate = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!/^[0-9]{5}$/.test(form.postal_code)) {
      setError('Postal Code must be 5 digits.');
      return;
    }
    try {
      await axios.post(`${API_BASE_URL}/api/address/`, form, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      setShowModal(false);
      setForm({ nickname: '', address_line1: '', address_line2: '', city: '', state: '', postal_code: '' });
      fetchAddresses();
      eventBus.emit('addressesChanged');
    } catch (err: any) {
      if (err.response && err.response.data) {
        const errors = err.response.data;
        setError(
          typeof errors === 'string'
            ? errors
            : Object.entries(errors).map(([field, msgs]) => {
                if (typeof msgs === 'object') {
                  return `${field}: ${JSON.stringify(msgs)}`;
                }
                return `${field}: ${Array.isArray(msgs) ? msgs.join(', ') : msgs}`;
              }).join(' | ')
        );
      } else {
        setError('An error occurred.');
      }
    }
  };

  return (
    <section style={{ marginBottom: 40 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2 style={{ fontSize: 22, fontWeight: 700 }}>Addresses</h2>
        <button onClick={() => setShowModal(true)} style={{ padding: '8px 16px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 600 }}>New Address</button>
      </div>
      {loading ? <div>Loading...</div> : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {addresses.map((addr: any) => (
            <li key={addr.id} style={{ background: '#f3f4f6', marginBottom: 8, padding: 12, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span>
                <strong>{addr.nickname}</strong> — {addr.address_line1}, {addr.city} {addr.state} {addr.postal_code}
              </span>
              <span style={{ display: 'flex', gap: 8 }}>
                <button onClick={() => { setEditId(addr.id); setEditForm({ nickname: addr.nickname, address_line1: addr.address_line1, address_line2: addr.address_line2, city: addr.city, state: addr.state, postal_code: addr.postal_code }); setEditError(null); }} style={{ padding: '4px 10px', background: '#fbbf24', color: '#333', border: 'none', borderRadius: 6, fontWeight: 600 }}>Edit</button>
                <button onClick={async () => { await axios.delete(`${API_BASE_URL}/api/address/${addr.id}/`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }); fetchAddresses(); }} style={{ padding: '4px 10px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 600 }}>Delete</button>
              </span>
            </li>
          ))}
        </ul>
      )}
      {showModal && (
        <div className="modal-overlay">
          <AddressModal
            mode="create"
            form={form}
            setForm={setForm}
            error={error}
            onSubmit={handleCreate}
            onCancel={() => setShowModal(false)}
            states={states}
          />
        </div>
      )}
      {editId !== null && (
        <div className="modal-overlay">
          <AddressModal
            mode="edit"
            form={editForm}
            setForm={setEditForm}
            error={editError}
            onSubmit={async e => {
              e.preventDefault();
              setEditError(null);
              try {
                await axios.patch(`${API_BASE_URL}/api/address/${editId}/`, editForm, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
                setEditId(null);
                fetchAddresses();
              } catch (err: any) {
                if (err.response && err.response.data) {
                  const errors = err.response.data;
                  setEditError(
                    typeof errors === 'string'
                      ? errors
                      : Object.entries(errors).map(([field, msgs]) => {
                          if (typeof msgs === 'object') {
                            return `${field}: ${JSON.stringify(msgs)}`;
                          }
                          return `${field}: ${Array.isArray(msgs) ? msgs.join(', ') : msgs}`;
                        }).join(' | ')
                  );
                } else {
                  setEditError('An error occurred.');
                }
              }
            }}
            onCancel={() => setEditId(null)}
            states={states}
          />
        </div>
      )}
    </section>
  );
}
